import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface IpPhoneEntryJson {
//  index:string;
//  mac_address: string;
//  ip_address: string;
//  name: string;
//  description: string;
//  serial_number: string;
//  user_name: string;
//  status: string;
//  time_last_registered: string;
//  e911_location: string;
//  load_id: string;
//  extensions: string;
//  product_type_string: string;
//  product_category_string: string;
//  phone_type: string;
//  product_category: string;
//}

export class IpPhoneEntry /*implements ISerializable*/ implements ObjectSerializer {
	// KEY
	public Index: number;

	// ATTRIBUTES
	public MacAddress: MacAddress;
	public IpAddress: IpAddress;

	public Name: string;
	public Description: string;
	public SerialNumber: string;
	public PartNumber: string;
	public UserName: string;

	public Status: string;
	public TimeLastRegistered: string;
	public E911Location: string;
	public LoadID: string;
	public Extensions: string;

	public PhoneType: number;

	public ProductTypeIndex: number;
	public ProductTypeToString: string;
	public ProductCategory: number;
	public ProductCategoryToString: string;

	public get HasMacAddress(): boolean {
		return !!this.MacAddress;
	}

	public get HasIpAddress(): boolean {
		return !!this.IpAddress;
	}

	public get HasName(): boolean {
		return !!this.Name;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public get HasSerialNumber(): boolean {
		return !!this.SerialNumber;
	}

	public get HasPartNumber(): boolean {
		return !!this.PartNumber;
	}

	public get HasUserName(): boolean {
		return !!this.UserName;
	}

	public get HasStatus(): boolean {
		return !!this.Status;
	}

	public get HasTimeLastRegistered(): boolean {
		return !!this.TimeLastRegistered;
	}

	public get HasE911Location(): boolean {
		return !!this.E911Location;
	}

	public get HasLoadID(): boolean {
		return !!this.LoadID;
	}

	public get HasExtensions(): boolean {
		return !!this.Extensions;
	}

	public get HasPhoneType(): boolean {
		return this.PhoneType >= 0;
	}

	public get HasProductTypeIndex(): boolean {
		return this.ProductTypeIndex >= 0;
	}

	public get HasProductCategory(): boolean {
		return this.ProductCategory >= 0;
	}

	public get HasProductTypeToString(): boolean {
		return !!this.ProductTypeToString;
	}

	public get HasProductCategoryToString(): boolean {
		return !!this.ProductCategoryToString;
	}

	constructor(phoneIndex?: number) {
		this.Index = phoneIndex;
		this.Init();
	}

	private Init(): void {
		this.MacAddress = null;
		this.IpAddress = null;

		this.Name = '';
		this.Description = '';
		this.SerialNumber = '';
		this.PartNumber = '';
		this.UserName = '';

		this.Status = '';
		this.TimeLastRegistered = '';
		this.E911Location = '';
		this.LoadID = '';
		this.Extensions = '';

		this.PhoneType = -1;
		this.ProductTypeIndex = -1;
		this.ProductTypeToString = '';
		this.ProductCategory = -1;
		this.ProductCategoryToString = '';
	}

	//public Deserialize(json: IpPhoneEntryJson) :void {
	//  if (json.index !== undefined)
	//    this.Index = parseInt(json.index);
	//  if (json.mac_address !== undefined)
	//    this.MacAddress = MacAddress.CreateFromString(json.mac_address);
	//  if (json.ip_address !== undefined)
	//    this.IpAddress = IpAddress.Create(json.ip_address);
	//  if (json.name !== undefined)
	//    this.Name = json.name;
	//  if (json.description !== undefined)
	//    this.Description = json.description;
	//  if (json.serial_number !== undefined)
	//    this.SerialNumber = json.serial_number;
	//  if (json.user_name !== undefined)
	//    this.UserName = json.user_name;
	//  if (json.status !== undefined)
	//    this.Status = json.status;
	//  if (json.time_last_registered !== undefined)
	//    this.TimeLastRegistered = json.time_last_registered
	//  if (json.e911_location !== undefined)
	//    this.E911Location = json.e911_location;
	//  if (json.load_id !== undefined)
	//    this.LoadID = json.load_id;
	//  if (json.extensions !== undefined)
	//    this.Extensions = json.extensions;
	//  if (json.product_type_string !== undefined)
	//    this.ProductTypeToString = json.product_type_string;
	//  if (json.product_category_string !== undefined)
	//    this.ProductCategoryToString = json.product_category_string;
	//  if (json.phone_type !== undefined)
	//    this.PhoneType = parseInt(json.phone_type);
	//  if (json.product_category !== undefined)
	//    this.ProductCategory = parseInt(json.product_category);
	//}

	public Write(obj: any, context: any): void {
		obj.ip_phone_entry = {};
		obj = obj.ip_phone_entry;

		obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasSerialNumber)
			obj.serial_number = this.SerialNumber;

		if (this.HasPartNumber)
			obj.part_number = this.PartNumber;

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasStatus)
			obj.status = this.Status;

		if (this.HasTimeLastRegistered)
			obj.time_last_registered = this.TimeLastRegistered;

		if (this.HasE911Location)
			obj.e911_location = this.E911Location;

		if (this.HasLoadID)
			obj.load_id = this.LoadID;

		if (this.HasExtensions)
			obj.extensions = this.Extensions;

		if (this.HasProductTypeToString)
			obj.product_type_string = this.ProductTypeToString;

		if (this.HasProductCategoryToString)
			obj.product_category_string = this.ProductCategoryToString;

		if (this.HasPhoneType)
			obj.phone_type = ValueEncoder.EncodeInteger(this.PhoneType);

		if (this.HasProductTypeIndex)
			obj.product_type_index = ValueEncoder.EncodeInteger(this.ProductTypeIndex);

		if (this.HasProductCategory)
			obj.product_category = ValueEncoder.EncodeInteger(this.ProductCategory);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_phone_entry)
			throw new Error();
		obj = obj.ip_phone_entry;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.serial_number !== undefined)
			this.SerialNumber = obj.serial_number;

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.status !== undefined)
			this.Status = obj.status;

		if (obj.time_last_registered !== undefined)
			this.TimeLastRegistered = obj.time_last_registered

		if (obj.e911_location !== undefined)
			this.E911Location = obj.e911_location;

		if (obj.load_id !== undefined)
			this.LoadID = obj.load_id;

		if (obj.extensions !== undefined)
			this.Extensions = obj.extensions;

		if (obj.product_type_string !== undefined)
			this.ProductTypeToString = obj.product_type_string;

		if (obj.product_category_string !== undefined)
			this.ProductCategoryToString = obj.product_category_string;

		if (obj.phone_type !== undefined)
			this.PhoneType = ValueEncoder.DecodeInteger(obj.phone_type);

		if (obj.product_type_index !== undefined)
			this.ProductTypeIndex = ValueEncoder.DecodeInteger(obj.product_type_index);

		if (obj.product_category !== undefined)
			this.ProductCategory = ValueEncoder.DecodeInteger(obj.product_category);
	}
}

export class IpPhoneTable extends InfoSetTable<number, IpPhoneEntry> {
	constructor(device: Device) {
		super(device);
	}

	public Add(phoneIndex: number): IpPhoneEntry {
		var ipPhoneEntry: IpPhoneEntry = null;

		if (this._table.ContainsKey(phoneIndex)) {
			ipPhoneEntry = this._table.Item(phoneIndex);
		}
		else {
			ipPhoneEntry = new IpPhoneEntry(phoneIndex);
			this._table.Add(phoneIndex, ipPhoneEntry);
		}

		return ipPhoneEntry;
	}

	private AddEntry(ipPhoneEntry: IpPhoneEntry): void {
		this._table.Add(ipPhoneEntry.Index, ipPhoneEntry);
	}

	public FindByExtension(phoneExt: string): IpPhoneEntry {
		var foundEntry: IpPhoneEntry = null;

		if (!!phoneExt) {
			this._table.Some((pair) => {
				if (!pair.Value)
					return;
				if (!pair.Value.HasExtensions)
					return;
				if (pair.Value.Extensions.toLowerCase() !== phoneExt.toLowerCase())
					return;

				foundEntry = pair.Value;
				return true;
			});
		}

		return (foundEntry);
	}

	public RemoveEntry(ipPhoneEntry: IpPhoneEntry): boolean {
		return ipPhoneEntry ? this._table.Remove(ipPhoneEntry.Index) : false;
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._table.ForEach((pair) => {
			if (pair.Value.HasIpAddress)
				ipAddresses.Add(pair.Value.IpAddress);
		});

		return (ipAddresses);
	}

	public SetProductTypeName(productTypeIndex: number, productTypeName: string, productCategoryIndex: number, productCategoryName: string): void {
		if (!this._table)
			return;

		this._table.ForEach((pair) => {
			if (pair.Value.ProductTypeIndex != productTypeIndex)
				return;

			pair.Value.ProductTypeToString = productTypeName;
			pair.Value.ProductCategory = productCategoryIndex;
			pair.Value.ProductCategoryToString = productCategoryName;
		});
	}

	//public DeserializeEntry(json: IpPhoneEntryJson): void {
	//  var entry = this.Add(parseInt(json.index));
	//  entry.Deserialize(json);
	//}

	//public EntryName(): string {
	//  return "ip_phone_entry";
	//};

	//public static FromJson(json: any, device: Device): IpPhoneTable {
	//  var result = new IpPhoneTable(device);
	//  result.Deserialize(json);
	//  return result;
	//}

	public Write(obj: any, context: any): void {
		obj.ip_phones_info = {};
		obj = obj.ip_phones_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_phones_info)
			throw new Error();
		obj = obj.ip_phones_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new IpPhoneEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
